import { useAuth } from '@/hooks/use-auth'
import { createMonitorBlock } from '@/lib/free-domain'

/** What stops this user from creating a monitor now, or null. */
export function useCreateMonitorBlock() {
  const { organization, user } = useAuth()
  return createMonitorBlock(organization, user)
}
